import { hubsMultiSelectIntlIds } from './hubs-multi-select.ids';

export const hubsMultiSelectLangPtBr = {
  [hubsMultiSelectIntlIds.allValuesLabel]: 'Todos os hubs',
  [hubsMultiSelectIntlIds.placeholder]: 'Selecione um ou mais hubs',
  [hubsMultiSelectIntlIds.noOptionsLabel]: 'Nenhuma opção disponível',
};
